import PropTypes from 'prop-types'
import styled from 'styled-components'

import Icon from 'components/Shared/Icon/Index'
import MiniChart from 'components/Shared/charts/MiniChart'
import LoadingIndicator from 'components/Shared/LoadingIndicator/Index'
import colors from 'components/utils/colors'

const StyledWrapper = styled.div`
  flex: 1;
  position: relative;
  padding: 12px 16px 0 16px;
  box-sizing: border-box;
  border: 2px solid transparent;
  border-radius: 3px;
  background-color: #FFFFFF;
  margin-right: 8px;
  align-items: center;

  &:last-child {
    margin-right: 0;
  }
`

const TitleBar = styled.div`
  display: flex;
  padding: 0 0 6px 0;
  user-select: none;
  align-items: baseline;
`

const Title = styled.div`
  font-family: Exo;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  color: ${props => props.color}
`

const Subtitle = styled.div`
  font-size: 12px;
  white-space: nowrap;
  color: ${colors.secondary20};
  padding-left: 5px;
`

const Content = styled.div`
  display: flex;
  flex: 1;
`

const StyledIcon = styled(Icon)`
  height: 16px;
  padding-top: 8px;
  padding-right: 6px;
`

const StyledValue = styled.div`
  font-family: Exo;
  font-size: 40px;
  color: ${colors.secondary20};
`

const ChartWrapper = styled.div`
  position: relative;
  flex: 1;
  height: 40px;
  max-height: 40px;
  margin-left: 16px;
  position: relative;
  top: -6px;
`

const StatsCard = ({ fetching, title, subtitle, color, icon, value, chartData, chartTimeZoneAbbr }) => {
  const chartConfig = { displayTimezone: chartTimeZoneAbbr }

  return (
    <StyledWrapper data-test='stats-card'>
      <LoadingIndicator loading={fetching} small />
      <TitleBar>
        <Title color={color}>{title}</Title>
        {subtitle && <Subtitle>{subtitle}</Subtitle>}
      </TitleBar>
      <Content>
        <StyledIcon iconName={icon} />
        <StyledValue data-test='stats-card-value'>{value}</StyledValue>
        {chartData && (
          <ChartWrapper>
            <MiniChart config={chartConfig} data={chartData} />
          </ChartWrapper>
        )}
      </Content>
    </StyledWrapper>
  )
}

StatsCard.propTypes = {
  fetching: PropTypes.bool,
  value: PropTypes.number,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  color: PropTypes.string,
  icon: PropTypes.string,
  chartData: PropTypes.object,
  chartTimeZoneAbbr: PropTypes.string,
}

export default StatsCard
